export const SHARE_DIALOG_BREAKPOINTS = [
    {
        query: "(max-width: 860px), (max-height: 620px)",
        paperMargin: 16,
        titlePadding: "16px 20px 14px 20px",
        iconFontSize: 28,
        iconVerticalAlign: "-7px",
        iconMarginRight: 8,
        dialogContentPaddingBottom: 10,
        dialogActionsPadding: "8px 20px 16px 20px",
        panelBorderRadius: 4,
        collaborateInviteMinHeight: 44,
        collaborateChipHeight: 24,
        collaborateInputHeight: 18,
        collaborateInputFontSize: 13,
        collaborateInputPadding: 2,
        collaborateTextAreaMinHeight: 32,
        collaborateTextAreaFontSize: 13,
        collaborateTextAreaPadding: "3px 8px",
    },
    {
        query: "(max-width: 640px), (max-height: 520px)",
        paperMargin: 8,
        titlePadding: "12px 14px 10px 14px",
        iconFontSize: 24,
        iconVerticalAlign: "-5px",
        iconMarginRight: 6,
        dialogContentPaddingBottom: 8,
        dialogActionsPadding: "8px 14px 12px 14px",
        panelBorderRadius: 3,
        collaborateInviteMinHeight: 36,
        collaborateChipHeight: 22,
        collaborateInputHeight: 16,
        collaborateInputFontSize: 12,
        collaborateInputPadding: 1,
        collaborateTextAreaMinHeight: 26,
        collaborateTextAreaFontSize: 12,
        collaborateTextAreaPadding: "2px 7px",
    }
];

export function buildShareDialogContainerResponsiveCss() {
    return SHARE_DIALOG_BREAKPOINTS.map(({
        query,
        paperMargin,
        titlePadding,
        iconFontSize,
        iconVerticalAlign,
        iconMarginRight,
        dialogContentPaddingBottom,
        dialogActionsPadding,
    }) => `
        @media ${query} {
            .MuiDialog-paper {
                margin: ${paperMargin}px;
                width: calc(100% - ${paperMargin * 2}px);
                max-width: none;
            }

            .MuiDialogTitle-root {
                padding: ${titlePadding};
            }

            .MuiDialogTitle-root .MuiIcon-root {
                font-size: ${iconFontSize}px;
                vertical-align: ${iconVerticalAlign};
                margin-right: ${iconMarginRight}px;
            }

            .dialog-content {
                padding-bottom: ${dialogContentPaddingBottom}px;
            }

            .MuiDialogActions-root {
                padding: ${dialogActionsPadding};
                flex-wrap: wrap;
                row-gap: 8px;
            }
        }
    `).join("\n");
}

export function buildShareDialogPanelResponsiveCss() {
    return SHARE_DIALOG_BREAKPOINTS.map(({ query, panelBorderRadius }) => `
        @media ${query} {
            max-width: 100%;
            border-radius: ${panelBorderRadius}px;
        }
    `).join("\n");
}

export function buildShareDialogCollaborateResponsiveCss() {
    return SHARE_DIALOG_BREAKPOINTS.map(({
        query,
        collaborateInviteMinHeight,
        collaborateChipHeight,
        collaborateInputHeight,
        collaborateInputFontSize,
        collaborateInputPadding,
        collaborateTextAreaMinHeight,
        collaborateTextAreaFontSize,
        collaborateTextAreaPadding,
    }) => `
        @media ${query} {
            .share-dialog-collaborate-content {
                padding-top: 0;
                padding-bottom: 0;
            }

            .share-dialog-collaborate-content .invite-input .tags-input {
                min-height: ${collaborateInviteMinHeight}px;
                height: ${collaborateInviteMinHeight}px;
                max-height: ${collaborateInviteMinHeight}px;
                overflow-y: auto;
                align-content: flex-start;
            }

            .share-dialog-collaborate-content .invite-input .MuiChip-root {
                height: ${collaborateChipHeight}px !important;
                min-height: ${collaborateChipHeight}px !important;
                margin: 1px !important;
            }

            .share-dialog-collaborate-content .invite-input input {
                height: ${collaborateInputHeight}px;
                font-size: ${collaborateInputFontSize}px;
                padding: ${collaborateInputPadding}px;
            }

            .share-dialog-collaborate-textarea {
                min-height: ${collaborateTextAreaMinHeight}px;
                height: ${collaborateTextAreaMinHeight}px;
                max-height: ${collaborateTextAreaMinHeight}px;
                overflow: hidden;
            }

            .share-dialog-collaborate-textarea .MuiInputBase-root {
                height: 100%;
                align-items: flex-start;
            }

            .share-dialog-collaborate-textarea textarea {
                padding: ${collaborateTextAreaPadding};
                font-size: ${collaborateTextAreaFontSize}px;
                line-height: 1.2;
                overflow-y: auto !important;
            }
        }
    `).join("\n");
}
